// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__Dx0T+","left":"Layout_left__ANkN-","mid":"Layout_mid__C3gs7","right":"Layout_right__GMUJg"};